export enum UserPositionEnum {
  Driver = 'driver',
  OfficeManager = 'office_manager',
  JobatorySupport = 'jobatory_support',
  AccountOwner = 'account_owner'
}
